import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { toast } from 'react-toastify';
import api from '../utils/api';
import ProductCard from '../components/ProductCard';

const CategoryCampaignPage = () => {
  const { campaignId } = useParams();
  const [searchParams] = useSearchParams();
  const { addToCart } = useCart();
  
  const [campaign, setCampaign] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCampaignData = async () => {
      try {
        setLoading(true);
        
        // URL'den campaign ID'yi al
        const id = campaignId || searchParams.get('campaign');
        
        if (!id) {
          // Aktif kategori kampanyalarını getir
          const response = await api('/api/campaigns/active-category-campaigns');
          console.log('🏷️ Aktif kategori kampanyaları yanıtı:', response);
          
          if (response.success && response.data && response.data.length > 0) {
            const activeCampaign = response.data[0];
            console.log('✅ Aktif kampanya bulundu:', activeCampaign.name);
            setCampaign(activeCampaign);
            await fetchCampaignProducts(activeCampaign.id);
          } else {
            console.log('❌ Aktif kategori kampanyası bulunamadı:', response);
            setError('Aktif kategori kampanyası bulunamadı');
          }
        } else {
          // Belirli kampanyayı getir
          console.log('🔍 Belirli kampanya getiriliyor:', id);
          const response = await api(`/api/campaigns/${id}`);
          console.log('📋 Kampanya yanıtı:', response);
          
          if (response.success && response.data) {
            setCampaign(response.data);
            await fetchCampaignProducts(id);
          } else {
            console.log('❌ Kampanya bulunamadı:', response);
            setError('Kampanya bulunamadı');
          }
        }
      } catch (err) {
        console.error('Kategori kampanyası yükleme hatası:', err);
        setError('Kampanya yüklenirken hata oluştu');
      } finally {
        setLoading(false);
      }
    };

    const fetchCampaignProducts = async (campaignId) => {
      try {
        console.log('📦 Kampanya ürünleri getiriliyor:', campaignId);
        const response = await api(`/api/campaigns/${campaignId}/products`);
        console.log('📋 Ürünler yanıtı:', response);
        
        if (response.success && response.data) {
          console.log('✅ Ürün sayısı:', response.data.length);
          setProducts(response.data);
        } else {
          console.log('❌ Ürün bulunamadı:', response);
          setProducts([]);
        }
      } catch (err) {
        console.error('❌ Kampanya ürünleri yükleme hatası:', err);
        setProducts([]);
      }
    };

    fetchCampaignData();
  }, [campaignId, searchParams]);

  const handleAddToCart = (product) => {
    // Varsayılan varyant ile sepete ekle
    const variant = product.variants?.[0] || { color: 'Standart', size: 'Std', price_override: null };
    
    addToCart(
      {
        id: product.id,
        name: product.name,
        price: product.price,
        main_image_url: product.main_image_url,
        category: product.category,
        campaign_id: campaign.id,
        campaign_type: 'category'
      },
      variant,
      1
    );
    toast.success('Sepete eklendi');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="container mx-auto px-4 py-8">
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="container mx-auto px-4 py-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">Kampanya Bulunamadı</h1>
            <p className="text-gray-600">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      
      {/* Kampanya Banner */}
      {campaign && (
        <div className="relative bg-gradient-to-r from-purple-600 to-pink-600 text-white">
          {campaign.banner_image_url && (
            <div className="absolute inset-0">
              <img 
                src={campaign.banner_image_url} 
                alt={campaign.name}
                className="w-full h-full object-cover opacity-30"
              />
            </div>
          )}
          <div className="relative container mx-auto px-4 py-16">
            <div className="text-center">
              <div className="inline-flex items-center space-x-2 mb-4">
                <span 
                  className="px-4 py-2 rounded-full text-sm font-bold"
                  style={{ backgroundColor: campaign.badge_color || '#8b5cf6' }}
                >
                  {campaign.badge_text || 'KATEGORİ KAMPANYASI'}
                </span>
              </div>
              <h1 className="text-4xl md:text-6xl font-bold mb-4">
                {campaign.name}
              </h1>
              <p className="text-xl md:text-2xl mb-6 opacity-90">
                {campaign.description}
              </p>
              <div className="flex justify-center items-center space-x-4">
                <div className="bg-white bg-opacity-20 rounded-lg p-4">
                  <div className="text-2xl font-bold">
                    %{campaign.discount_value}
                  </div>
                  <div className="text-sm opacity-80">İndirim</div>
                </div>
                <div className="bg-white bg-opacity-20 rounded-lg p-4">
                  <div className="text-2xl font-bold">
                    {products.length}
                  </div>
                  <div className="text-sm opacity-80">Ürün</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Ürünler */}
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Kampanya Ürünleri
          </h2>
          <p className="text-gray-600">
            {products.length} ürün bulundu
          </p>
        </div>

        {products.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {products.map((product) => (
              <div key={product.id} className="relative">
                <ProductCard product={product} />
                
                {/* Kampanya Badge */}
                <div className="absolute top-2 left-2 z-10">
                  <span 
                    className="px-2 py-1 text-xs font-bold text-white rounded-full"
                    style={{ backgroundColor: campaign.badge_color || '#8b5cf6' }}
                  >
                    %{campaign.discount_value} İNDİRİM
                  </span>
                </div>

                {/* Hızlı Sepete Ekle */}
                <div className="absolute bottom-2 right-2">
                  <button
                    onClick={() => handleAddToCart(product)}
                    className="bg-purple-600 hover:bg-purple-700 text-white p-2 rounded-full shadow-lg transition-colors"
                    title="Sepete Ekle"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="text-gray-400 mb-4">
              <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-600 mb-2">
              Henüz ürün eklenmemiş
            </h3>
            <p className="text-gray-500">
              Bu kampanyaya ürünler yakında eklenecek
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryCampaignPage;